import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/inherits";
import React from 'react';
import { CloudUpload as CloudUploadIcon } from '@material-ui/icons';
import classNames from 'classnames';

var DropZone =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DropZone, _React$Component);

  function DropZone(props) {
    var _this;

    _classCallCheck(this, DropZone);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DropZone).call(this, props));

    _this.openFileDialog = function () {
      if (!_this.props.disabled) {
        _this.fileInputRef.current.click();
      }
    };

    _this.onAddNewFiles = function (event) {
      if (!_this.props.disabled) {
        var files = event.target.files;

        if (_this.props.onAddNewFiles) {
          var array = _this.fileListToArray(files);

          _this.props.onAddNewFiles(array);

          _this.fileInputRef.current.value = null;
        }
      }
    };

    _this.onDragOver = function (event) {
      event.preventDefault();

      if (!_this.props.disabled) {
        _this.setState({
          highlight: true
        });
      }
    };

    _this.onDragLeave = function () {
      _this.setState({
        highlight: false
      });
    };

    _this.onDrop = function (event) {
      event.preventDefault();

      if (!_this.props.disabled) {
        var files = event.dataTransfer.files;

        if (_this.props.onAddNewFiles) {
          var array = _this.fileListToArray(files);

          _this.props.onAddNewFiles(array);
        }

        _this.setState({
          highlight: false
        });
      }
    };

    _this.fileListToArray = function (list) {
      var extensions = _this.props.extensions;
      var array = [];

      for (var i = 0; i < list.length; i++) {
        var file = list.item(i);

        if (!extensions || extensions && extensions.includes(file.name.split('.').pop())) {
          array.push(file);
        }
      }

      return array;
    };

    _this.state = {
      highlight: false
    };
    _this.fileInputRef = React.createRef();
    return _this;
  }

  _createClass(DropZone, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          extensions = _this$props.extensions;
      return React.createElement("div", {
        className: classNames(classes.dropZone, this.state.highlight ? classes.dropZoneHighlighted : ''),
        onDragOver: this.onDragOver,
        onDragLeave: this.onDragLeave,
        onDrop: this.onDrop,
        onClick: this.openFileDialog,
        style: {
          cursor: this.props.disabled ? 'default' : 'pointer'
        }
      }, React.createElement("input", {
        ref: this.fileInputRef,
        className: classes.fileInput,
        type: 'file',
        multiple: true,
        accept: extensions ? extensions.map(function (extension) {
          return ".".concat(extension);
        }).join(',') : '',
        onChange: this.onAddNewFiles
      }), React.createElement("span", {
        className: classes.dropZonePlaceholder
      }, "\u041A\u043B\u0438\u043A\u043D\u0438\u0442\u0435 \u0438\u043B\u0438 \u043F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u0435 \u0444\u0430\u0439\u043B\u044B \u0432 \u044D\u0442\u0443 \u043E\u0431\u043B\u0430\u0441\u0442\u044C", ' ', extensions && React.createElement("strong", null, "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0435 \u0442\u0438\u043F\u044B \u0444\u0430\u0439\u043B\u043E\u0432: ".concat(extensions.join(', ')))), React.createElement(CloudUploadIcon, {
        className: classes.dropZoneIcon,
        fontSize: 'large'
      }));
    }
  }]);

  return DropZone;
}(React.Component);

export default DropZone;